import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { TranslocoModule } from '@ngneat/transloco';

import { DebounceClickDirectiveModule } from 'src/app/directives/debounce-click/debounce-click-directive.module';
import { GiftCardSelectionComponent } from './gift-card-selection.component';

@NgModule({
  declarations: [GiftCardSelectionComponent],
  imports: [
    CommonModule,
    IonicModule,
    TranslocoModule,
    DebounceClickDirectiveModule
  ],
  exports: [GiftCardSelectionComponent]
})
export class GiftCardSelectionModule {}
